import {
  FiUsers,
  FiShoppingCart,
  FiSettings,
  FiGift,
  FiUserCheck,
  FiLogOut,
  FiChevronDown,
  FiBox,
  FiActivity,
  FiDollarSign,
  FiCode,
  FiFlag,
  FiHelpCircle,
  FiCheckCircle,

} from "react-icons/fi";
import { NavLink } from "react-router-dom";
import { useState } from "react";
import { TbMoneybag } from "react-icons/tb";
import { useAuth } from "../../context/AuthContext";
import { MdOutlineStackedBarChart } from "react-icons/md";

const menu = [
  { label: "Dashboard", icon: FiBox, to: "/" },
  { label: "Analytics", icon: MdOutlineStackedBarChart, to: "/analytics" },
  { label: "Members", icon: FiUsers, to: "/users" },
  { label: "Bonus & Penalty", icon: FiGift, to: "/bonus-and-panelty" },
  { label: "Bonus History", icon: FiActivity, to: "/bonus-and-panelty-history" },
  { label: "Recharge List", icon: TbMoneybag, to: "/recharge-list" },
  { label: "Withdrawal List", icon: FiShoppingCart, to: "/withdrawal-list" },
  { label: "Gift Codes", icon: FiGift, to: "/gift-codes" },
  // {
  //   label: "Support",
  //   icon: FiHelpCircle,
  //   children: [
  //     { label: "Pending Issues", icon: FiHelpCircle, to: "/pending-issues" },
  //     { label: "Resolved Issues", icon: FiCheckCircle, to: "/resolved-issues" },
  //   ],
  // },
  { label: "API Management", icon: FiCode, to: "/api-management" },
  { label: "Milestones", icon: FiFlag, to: "/milestones" },
  {
    label: "Settings",
    icon: FiSettings,
    children: [
      { label: "Deposit Bonus", icon: FiDollarSign, to: "/settings/deposit/bonus" },
      { label: "Daily Sign-in", icon: FiGift, to: "/settings/daily-signin" },
      { label: "5% Cashback", icon: FiActivity, to: "/settings/cashback" },
      { label: "General Settings", icon: FiSettings, to: "/settings/general" },
      { label: "Payment Methods", icon: FiSettings, to: "/settings/payments" },
    ],
  },
  { label: "Admin", icon: FiUserCheck, to: "/admin" },
];

/* ─── color tokens (Dark Theme) ─── */
const GREEN = "#10B981";        /* active border / icon / text (emerald) */
const GREEN_BG = "rgba(16, 185, 129, 0.12)";     /* active background */
const TEXT_PRIMARY = "#E2E8F0"; /* nav label (light slate) */
const TEXT_MUTED = "#94A3B8";   /* icon / subtitle (slate-400) */
const BORDER = "#1E293B";       /* dividers / borders (slate-800) */
const BG = "#0F172A";           /* sidebar dark bg (slate-900) */
const HOVER_BG = "rgba(255, 255, 255, 0.06)";

const Sidebar = ({ isOpen, onClose }) => {
  const [openGroups, setOpenGroups] = useState({});
  const { user, logout } = useAuth();

  const toggleGroup = (label) =>
    setOpenGroups((prev) => ({ ...prev, [label]: !prev[label] }));

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-20 md:hidden"
          onClick={onClose}
        />
      )}

      <aside
        className={`
          fixed z-30 inset-y-0 left-0 w-72
          transform transition-transform duration-300 ease-in-out
          ${isOpen ? "translate-x-0" : "-translate-x-full"}
          md:static md:translate-x-0
          flex flex-col
        `}
        style={{
          background: BG,
          borderRight: `1px solid ${BORDER}`,
          fontFamily: "'Inter', sans-serif",
        }}
      >
        {/* ── Logo ── */}
        <div
          style={{
            padding: "20px 20px 16px",
            borderBottom: `1px solid ${BORDER}`,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            {/* Dark green badge */}
            <div
              style={{
                width: 42,
                height: 42,
                borderRadius: 12,
                background: "linear-gradient(135deg, #064E3B 0%, #065F46 100%)",
                border: "1px solid rgba(16, 185, 129, 0.3)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                boxShadow: "0 2px 10px rgba(16, 185, 129, 0.2)",
              }}
            >
              {/* Circle-inside-square icon */}
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <circle
                  cx="12"
                  cy="12"
                  r="8"
                  stroke="#34D399"
                  strokeWidth="2"
                  fill="none"
                />
                <circle cx="12" cy="12" r="3" fill="#34D399" />
              </svg>
            </div>

            <div>
              <p
                style={{
                  fontWeight: 700,
                  fontSize: 16,
                  color: "#FFFFFF",
                  margin: 0,
                  lineHeight: 1.25,
                  letterSpacing: "-0.01em",
                }}
              >
                Pori420
              </p>
              <p
                style={{
                  fontWeight: 400,
                  fontSize: 11,
                  color: TEXT_MUTED,
                  margin: 0,
                  marginTop: 2,
                }}
              >
                Admin Portal
              </p>
            </div>
          </div>
        </div>

        {/* ── Navigation ── */}
        <nav
          className="sidebar-scroll"
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "12px 12px",
          }}
        >
          {menu.map((item) => {
            const Icon = item.icon;
            const hasChildren = !!item.children?.length;
            const isGroupOpen = openGroups[item.label];

            if (!hasChildren) {
              return (
                <NavLink
                  key={item.label}
                  to={item.to}
                  end={item.to === "/"}
                  onClick={onClose}
                  style={({ isActive }) => ({
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    padding: "10px 14px",
                    borderRadius: 10,
                    marginBottom: 4,
                    textDecoration: "none",
                    fontSize: 14,
                    fontWeight: isActive ? 600 : 500,
                    color: isActive ? GREEN : TEXT_PRIMARY,
                    background: isActive ? GREEN_BG : "transparent",
                    border: isActive
                      ? `1.5px solid ${GREEN}`
                      : "1.5px solid transparent",
                    transition: "all 0.15s ease",
                  })}
                  className="sb-link"
                >
                  {({ isActive }) => (
                    <>
                      <Icon
                        style={{
                          fontSize: 18,
                          color: isActive ? GREEN : TEXT_MUTED,
                          flexShrink: 0,
                          transition: "color 0.15s ease",
                        }}
                      />
                      <span>{item.label}</span>
                    </>
                  )}
                </NavLink>
              );
            }

            /* ── Group ── */
            return (
              <div key={item.label} style={{ marginBottom: 4 }}>
                <button
                  onClick={() => toggleGroup(item.label)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    width: "100%",
                    padding: "10px 14px",
                    borderRadius: 10,
                    border: "1.5px solid transparent",
                    background: isGroupOpen ? "rgba(255, 255, 255, 0.04)" : "transparent",
                    color: TEXT_PRIMARY,
                    fontSize: 14,
                    fontWeight: 500,
                    cursor: "pointer",
                    textAlign: "left",
                    transition: "all 0.15s ease",
                  }}
                  className="sb-group"
                >
                  <Icon
                    style={{ fontSize: 18, color: TEXT_MUTED, flexShrink: 0 }}
                  />
                  <span style={{ flex: 1 }}>{item.label}</span>
                  <FiChevronDown
                    style={{
                      fontSize: 14,
                      color: TEXT_MUTED,
                      transform: isGroupOpen ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.2s ease",
                    }}
                  />
                </button>

                {isGroupOpen && (
                  <div
                    style={{
                      marginLeft: 18,
                      paddingLeft: 12,
                      borderLeft: `2px solid rgba(255, 255, 255, 0.12)`,
                      marginTop: 4,
                      marginBottom: 6,
                    }}
                  >
                    {item.children.map((child) => {
                      const ChildIcon = child.icon;
                      return (
                        <NavLink
                          key={child.label}
                          to={child.to}
                          onClick={onClose}
                          style={({ isActive }) => ({
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            padding: "8px 12px",
                            borderRadius: 8,
                            marginBottom: 2,
                            textDecoration: "none",
                            fontSize: 13,
                            fontWeight: isActive ? 600 : 500,
                            color: isActive ? GREEN : TEXT_MUTED,
                            background: isActive ? GREEN_BG : "transparent",
                            transition: "all 0.15s ease",
                          })}
                          className="sb-link"
                        >
                          {({ isActive }) => (
                            <>
                              {ChildIcon && (
                                <ChildIcon
                                  style={{
                                    fontSize: 14,
                                    color: isActive ? GREEN : TEXT_MUTED,
                                  }}
                                />
                              )}
                              <span>{child.label}</span>
                            </>
                          )}
                        </NavLink>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </nav>
        {/* ── Bottom footer / border ── */}
      </aside>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

        .sidebar-scroll::-webkit-scrollbar { width: 4px; }
        .sidebar-scroll::-webkit-scrollbar-track { background: transparent; }
        .sidebar-scroll::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.12);
          border-radius: 8px;
        }
        .sidebar-scroll::-webkit-scrollbar-thumb:hover { background: rgba(255, 255, 255, 0.25); }

        .sb-link:not([style*="background: rgba(16, 185, 129"]):hover {
          background: rgba(255, 255, 255, 0.07) !important;
          color: #FFFFFF !important;
        }
        .sb-link:not([style*="background: rgba(16, 185, 129"]):hover svg {
          color: #FFFFFF !important;
        }
        .sb-group:hover {
          background: rgba(255, 255, 255, 0.07) !important;
          color: #FFFFFF !important;
        }
        .sb-group:hover svg {
          color: #FFFFFF !important;
        }
      `}</style>
    </>
  );
};

export default Sidebar;